// extracted by mini-css-extract-plugin
module.exports = {"Container":"BackgroundVideo_Container__3Om3b","Video":"BackgroundVideo_Video__3yrGP"};